import React from 'react';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';

import Paper from '@material-ui/core/Paper';

import { PRODOTTO_MULTINVEST_M111} from '../../../../utility/jsConstants';
    
const styles = theme => ({
  paperStyle: theme.paperStyle,	
  fieldSet: theme.fieldSet,
  divider: {
    width: theme.spacing(1),
  },
});


const mapStateToProps = state => {
  //console.log('#RTCFA DatiLifeCycle.mapStateToProps.state', state);
  return {
    prodotto: state.areaProdottoReducer.prodotto,
  };
};
	
const mapDispatchToProps = dispatch => {
  //console.log('#RTCFA DatiLifeCycle.mapDispatchToProps.dispatch', dispatch);
  return {

  };
};
	
class DatiLifeCycle extends React.Component {
	
  constructor(props) {
    super(props);
    this.state = {
    };
  };

  render() {
    const { classes, prodotto } = this.props;
    const { t } = this.props; //hoc    
    return (
      <Fragment>
      {/*<fieldset className={classes.fieldSet}>
        <legend><Typography variant="subtitle1">{t('lifeCycle')}</Typography></legend>
        <DividerComp titolo='lifeCycle' variant="subtitle1" />*/}
        <Grid container direction="row" justify="center" alignItems="flex-start">
          {/* 2026-03-25 PFD: PRODOTTO MUTINVEST PRO M122 */}
	          {(prodotto.codice === PRODOTTO_MULTINVEST_M111) && 
	          <Grid item xs={12}>
	            <Paper className={classes.paperStyle} elevation={0}>
	              <Typography variant="caption">{t('legendaLifeCycle')}</Typography>
	            </Paper>
	          </Grid>
          }
        </Grid>
      {/*</fieldset>*/}
      </Fragment>
    );
  }
}

DatiLifeCycle.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withStyles(styles)(DatiLifeCycle)));

